<script lang="js" setup>
import { usePanelStore } from '~/store/panel'
import { useFutureStore } from '~/store/future'
import { usePanel } from '~/hooks/panel'
import { add, div, fix, mul } from '~/utils/math'

const props = defineProps({
  side: Number,
  default: () => 1,
})

const { t } = useI18n()
const future = useFutureStore()
const panel = usePanelStore()
const { unitName } = usePanel()

// U成本
const getCost = computed(() => {
  return side => mul(panel.getPanelLots(side) || 0, future.getOneLotCost({ price: panel.getPriceBySide({ side }) || 0 }))
})

const list = computed(() => {
  const { side } = props
  const { leverage } = future.positionConfig
  return [{
    k: 'cost',
    label: t('成本'),
    value: `${fix(getCost.value(side), future.ps)} ${future.quote}`,
    tip: future.isGrants ? t('开仓所需的成本，具体保证金以实际订单为准，受币对最小下单数量限制，赠金面额可能无法完全使用，未开仓部分面额将失效查看规则详情') : t('提交此委托所需的保证金'),
    vIf: !panel.isClosePosotion,
  }, {
    k: 'maxOpen',
    label: panel.isClosePosotion ? t('可平') : t('可开'),
    value: `${fix(panel.lots2Result(panel.maxOpen({ side }), side), future.scale)} ${unitName.value}`,
    tip: future.isGrants ? t('受实际成本的影响，实际的可开可能与显示不同，仅供参考') : panel.isClosePosotion ? '' : side === 1 ? t('您在当前{0}x杠杆下的买入（开多）的最大数量', [leverage]) : t('您在当前{0}x杠杆下的卖出（开空）的最大数量', [leverage]),
  }]
})
</script>

<template>
  <div class="space-y-1">
    <template v-for="i in list">
      <div v-if="!('vIf' in i) || i.vIf" :key="i.key" class="text-[10px] font-medium">
        <n-tooltip trigger="hover" placement="top" class="max-w-[300px]" :disabled="!i.tip">
          <template #trigger>
            <span
              class="text-textSecondary"
              :class="{
                'border-b border-dashed border-t2': i.tip,
              }"
            >{{ i.label }}:&nbsp;</span>
          </template>
          <div class="text-xs">
            {{ i.tip }}
          </div>
        </n-tooltip>
        <span>{{ i.value }}</span>
      </div>
    </template>
  </div>
</template>
